import { render, staticRenderFns } from "./HealthEducationList.vue?vue&type=template&id=f9426ea8&scoped=true"
import script from "./HealthEducationList.vue?vue&type=script&lang=js"
export * from "./HealthEducationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9426ea8",
  null
  
)

export default component.exports